import React from 'react';
import HeaderFour from '../../common/header/HeaderFour';
import BannerThree from '../../components/section-components/BannerThree';
import WelcomeFour from '../../components/section-components/WelcomeFour';
import AwardTwo from '../../components/section-components/AwardTwo';
import Experiences from '../../components/section-components/Experiences';
import PracticeAreasFour from '../../components/section-components/PracticeAreasFour';
import OurAttorneysFour from '../../components/section-components/OurAttorneysFour';
import Counter from '../../components/section-components/Counter';
import BlogFour from '../../components/section-components/BlogFour';
import TestimonialFour from '../../components/section-components/TestimonialFour';
import FooterFour from '../../common/footer/FooterFour';

const HomeFour = () => {
    return (
        <>
        <HeaderFour />

        <BannerThree />
        
        <WelcomeFour />
        
        <AwardTwo /> 
        
        <Experiences />
        
        <PracticeAreasFour />
        
        <OurAttorneysFour />
        
        <Counter />
        
        <BlogFour />
        
        <TestimonialFour />
        
        <FooterFour />
        </>
        )
}
    
export default HomeFour;